export default {
    locale: 'ro',
    currency: 'eur',
    showLots: false,
    list: [],
    loading: true,
    resetList: [],
    user: null,
    auction: null,
    lot: null,
    lots: [],
    bids: [],
    bidders: [],
    selectedLot: null,
    winner: null,
    log: [],
    pings: [],
    messages: [],
    warn: null,
    timer: null,
}
